import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { Button } from 'primeng/button';

@Component({
  selector: 'app-modal-buttons',
  standalone: true,
  imports: [CommonModule, TranslocoPipe, Button],
  template: `
    @if (showPrintButton() && false) {
      <p-button
        [attr.aria-label]="'global.print' | transloco"
        [attr.title]="'global.print' | transloco"
        icon="pi pi-print"
        size="small"
        [outlined]="true"
        severity="info"
        (onClick)="onPrintClick()" />
    }

    @if (showCloseButton() !== false) {
      <p-button
        size="small"
        severity="contrast"
        icon="pi pi-times"
        class=""
        styleClass="border !border-white hover:!border-black overflow-hidden"
        [attr.aria-label]="'global.close' | transloco"
        [attr.title]="'global.close' | transloco"
        (onClick)="onCloseClick($event)"
        data-testid="close-modal-button" />
    }
  `,
  host: { class: 'flex items-center gap-2' },
})
export class ModalButtonsComponent {
  showPrintButton = input(false);
  showCloseButton = input(true);

  closeClick = output<Event>();

  onPrintClick() {
    window.print();
  }

  onCloseClick(event: Event) {
    this.closeClick.emit(event);
  }
}
